module.exports = __webpack_public_path__ + "media/images/menu/aquila-d5348628def9d27847e8ff2fcdc75089.jpg";